<template>
  <div class="position-relative">
    <section class="section section-shaped my-0">
      <div class="shape shape-default">
      </div>
      <div class="container shape-container d-flex">
        <div class="col px-0">
          <div class="row">
            <div class="col-lg-6">
              <h1 class="display-3 text-white">個人誌一覧
              </h1>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section-lg">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">新刊</h2>
            <p v-if="NewBooks.length" class="lead">現在の新刊は以下の通りです</p>
            <div v-else class="spinner-border" role="status"><span class="sr-only">Loading...</span></div>
          </div>
        </div>
        <div v-for="(item,index) in NewBooks" :key="item.id">
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <h3>{{ item.attributes.Name }}</h3>
                <div v-if="item.attributes.SubTitle != null">
                  <h6>{{ item.attributes.SubTitle }}</h6>
                </div>
                <div v-if="item.attributes.DisplayCPName != null">
                  <h5>{{ item.attributes.DisplayCPName }}{{ item.attributes.Type }}</h5>
                </div>
                <div v-else>
                  <h5>{{ item.attributes.MainCharacter }}中心{{ item.attributes.Type }}</h5>
                </div>
                <div v-if="item.attributes.OtherCharacters != null">
                  <h6>　　その他主要人物：
                    <span v-for="(item2, index) in item.attributes.OtherCharacters" :key="item2.id">
                  {{ item2 }}
                  <span v-if="index != item.attributes.OtherCharacters.length - 1">,&nbsp;</span>
                </span>
                  </h6>
                </div>
                <h5>サイズ：{{ item.attributes.Size }} {{ item.attributes.Pages }}P</h5>
                <h5>発行日：{{ item.attributes.PublishDate }}（{{ item.attributes.EventName }}）</h5>
                <h5>価格：{{ item.attributes.Price }} 円（イベント頒布価格）</h5>
                <p class="lead">{{ item.attributes.Lead }}</p>
                <p v-html="item.attributes.Description"></p>
                <div class="btn-wrapper">
                  <span v-if="item.attributes.OnSaleWithPaper == true && item.attributes.OnlineStore">
                    <a :href="item.attributes.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="ni ni-cart">
                        BOOTHで購入
                      </base-button>
                    </a>
                  </span>
                  <span v-else-if="item.attributes.OnSaleWithPaper == true && !item.attributes.OnlineStore">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="fa fa-clock-o" disabled>
                      BOOTH準備中
                    </base-button>
                  </span>
                  <span v-else-if="item.attributes.OnSaleWithDigital == true">
                    <a :href="item.attributes.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="ni ni-tablet-button">
                        BOOTHで購入(電子版)
                      </base-button>
                    </a>
                  </span>
                  <span v-else>
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="default" disabled
                                 icon="ni ni-fat-remove">
                      完売しました
                    </base-button>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <img :src=item.attributes.Image.data.attributes.url class="img-fluid">
            </div>
          </div>
          <hr v-show="index !== NewBooks.length - 1">
        </div>
      </div>
    </section>
    <section class="section section-lg bg-secondary">
      <div class="container pt-lg">
        <div class="row text-center justify-content-center">
          <div class="col-lg-10">
            <h2 class="display-3">既刊一覧</h2>
          </div>
        </div>
        <div v-for="(item,index) in Books" :key="item.id">
          <div class="row row-grid align-items-center">
            <div class="col-md-8 order-md-1">
              <div class="pr-md-5">
                <h3>{{ item.attributes.Name }}</h3>
                <div v-if="item.attributes.SubTitle != null">
                  <h6>{{ item.attributes.SubTitle }}</h6>
                </div>
                <div v-if="item.attributes.DisplayCPName != null">
                  <h5>{{ item.attributes.DisplayCPName }}{{ item.attributes.Type }}</h5>
                </div>
                <div v-else>
                  <h5>{{ item.attributes.MainCharacter }}中心{{ item.attributes.Type }}</h5>
                </div>
                <h5>サイズ：{{ item.attributes.Size }} {{ item.attributes.Pages }}P</h5>
                <h5>発行日：{{ item.attributes.PublishDate }}（{{ item.attributes.EventName }}）</h5>
                <h5>価格：{{ item.attributes.Price }} 円（イベント頒布価格）</h5>
                <p class="lead">{{ item.attributes.Lead }}</p>
                <div class="btn-wrapper">
                  <router-link :to="item.attributes.BookDetailUrl">
                    <base-button :id="item.attributes.BookId" class="mb-3 mb-sm-0"
                                 outline type="primary"
                                 icon="ni ni-book-bookmark">
                      詳細情報
                    </base-button>
                  </router-link>
                  &nbsp;
                  <span v-if="item.attributes.OnSaleWithPaper == true && item.attributes.OnlineStore">
                    <a :href="item.attributes.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="ni ni-cart">
                        BOOTHで購入
                      </base-button>
                    </a>
                  </span>
                  <span v-else-if="item.attributes.OnSaleWithPaper == true && !item.attributes.OnlineStore">
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="warning"
                                 icon="fa fa-clock-o" disabled>
                      BOOTH準備中
                    </base-button>
                  </span>
                  <span v-else-if="item.attributes.OnSaleWithDigital == true">
                    <a :href="item.attributes.OnlineStore" target="_blank">
                      <base-button class="mb-3 mb-sm-0"
                                   outline type="warning"
                                   icon="ni ni-tablet-button">
                        BOOTHで購入(電子版)
                      </base-button>
                    </a>
                  </span>
                  <span v-else>
                    <base-button class="mb-3 mb-sm-0"
                                 outline type="default" disabled
                                 icon="ni ni-fat-remove">
                      完売しました
                    </base-button>
                  </span>
                </div>
              </div>
            </div>
            <div class="col-md-4 order-md-2">
              <div v-if="item.attributes.Image.data !== null">
                <img :src=item.attributes.Image.data.attributes.url class="img-fluid">
              </div>
            </div>
          </div>
          <hr v-show="index !== Books.length - 1">
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import 'moment/locale/ja'
import moment from "moment";

export default {
  name: "books",
  components: {
    moment
  },
  data() {
    return{
      Books: [],
      NewBooks: [],
      Events: [],
    };
  },
  head: {
    meta: function () {
      return [
        { property: 'og:title', content: '雛菊書房 - 個人誌一覧' },
        { property: 'og:type', content: 'website' },
        { property: 'og:description', content: '小説二次創作中心同人小説サークル「雛菊書房」が発行している個人誌一覧' },
        { property: 'og:image', content: location.origin + '/img/brand/default.png' },
        { property: 'twitter:card', content: 'summary' },
      ]
    }
  },
  created() {
    moment.locale('ja')
    this.getEvents()
    this.getBooks()
    //this.getNewBooks()
  },
  methods: {
    getBooks() {
      this.axios.get('/strapi/api/book-informations?populate=%2A&filters[IsAnthology][$eq]=false&pagination[pageSize]=100')
        .then(response =>{
          this.Books = response.data.data
          this.Books.forEach(function (value, index, array){
            if(value['attributes']['EventId'] !== null){
              if(this.Events.find(el => Number(el.id) == Number(value['attributes']['EventId'])) != null) {
                array[index]['attributes']['EventName'] = this.Events.find(el => el.id == value['attributes']['EventId']).attributes.Name
                array[index]['attributes']['EventInfo'] = this.Events.find(el => el.id == value['attributes']['EventId']).attributes
              }
            }
            switch (value['attributes']['Size']){
              case 'Duodecimo':
                array[index]['attributes']['Size'] = "四六判";
                break;
              case 'Paperback':
                array[index]['attributes']['Size'] = "文庫";
                break;
              case 'Others':
                array[index]['attributes']['Size'] = "その他";
                break;
              default:
                break;
            }
            switch (value['attributes']['Type']){
              case 'Normal':
                array[index]['attributes']['Type'] = "小説本";
                break;
              case 'Short':
                array[index]['attributes']['Type'] = "短編小説本";
                break;
              case 'ShortStories':
                array[index]['attributes']['Type'] = "短編集";
                break;
              case 'Series':
                array[index]['attributes']['Type'] = "小説本(シリーズ)";
                break;
              case 'LongStory':
                array[index]['attributes']['Type'] = "中長編小説本";
                break;
              case 'StoryAnthology':
                array[index]['attributes']['Type'] = "小説合同誌・アンソロジー";
                break;
              case 'StoryComicsAnthology':
                array[index]['attributes']['Type'] = "小説漫画合同誌・アンソロジー";
                break;
              case 'AllTypeAnthology':
                array[index]['attributes']['Type'] = "合同誌・アンソロジー";
                break;
              case 'Others':
                array[index]['attributes']['Type'] = value['attributes']['OtherType'];
                break;
              default:
                break;
            }
            array[index]['attributes']['PublishDate'] = moment(value['attributes']['PublishDate']).format('YYYY/MM/DD')
            if (array[index]['attributes']['Description'] !== null){
              array[index]['attributes']['Description'] = value['attributes']['Description'].replace(/\r?\n/g, '<br >');
            }
            array[index]['attributes']['BookDetailUrl'] = "/bookDetail/" + value['attributes']['BookId']
            if(array[index]['attributes']['Image']['data']){
              array[index]['attributes']['Image']['data']['attributes']['url'] = '/strapi' + value['attributes']['Image']['data']['attributes']['url']
            }
          }, this)
          let MostNewPublishDate = this.Books.sort(function (a, b){
            return (a.attributes.PublishDate > b.attributes.PublishDate) ? -1 : 1;
          })[0].attributes.PublishDate
          this.NewBooks = this.Books.filter(el => el.attributes.PublishDate == MostNewPublishDate)
        }).catch(error =>{
          console.log(error)
      })
    },
    getEvents() {
      this.axios.get('/strapi/api/event-informations?pagination[pageSize]=50')
          .then(response =>{
            this.Events = response.data.data
          }).catch(error =>{
        console.log(error)
      })
    },
  }
};
</script>
<style>
</style>
